import { useEffect, useRef } from "react";
import { Flex } from "@fluentui/react-northstar";
import Message from "./Message";
import { useChatStore } from "../../stores/useChatStore";
import TypingIndicator from "./TypingIndicator";

const MessagesContainer = ({
    histories = [],
    isLoadingResponse = false,
    currentQuestion,
    newResponse,
}) => {
    const messagesContainerRef = useRef(null);
    const messagesEndRef = useRef(null);

    const scrollToBottom = ({ scrollToBottom }) => {
        const container = messagesContainerRef.current;
        const lastMessage = messagesEndRef.current;
        if (container && lastMessage) {
            container.scrollTo({
                top: scrollToBottom
                    ? container.scrollHeight
                    : lastMessage.offsetTop - 80,
                behavior: "smooth",
            });
        }
    };

    useEffect(() => {
        scrollToBottom({ scrollToBottom: isLoadingResponse });
    }, [isLoadingResponse]);

    return (
        <Flex
            column
            styles={{
                flex: 1,
                height: "100%",
                overflowY: "auto",
                padding: "16px",
                backgroundColor: "#FAFAFA",
                overscrollBehaviorY: "none",
            }}
            ref={messagesContainerRef}
        >
            {histories.map((message, index) => (
                <>
                    <Message
                        key={"question_" + index}
                        message={message.question}
                        isQuestion={true}
                    />
                    {newResponse.length === 0 &&
                        index === histories.length - 1 && (
                            <div ref={messagesEndRef} />
                        )}
                    <Message key={"answer_" + index} message={message.answer} />
                </>
            ))}
            {newResponse.map((discussion, index) => {
                return (
                    <>
                        <Message
                            key={"nr_question" + index}
                            message={discussion.question}
                            isQuestion={true}
                        />
                        {index === newResponse.length - 1 && (
                            <div ref={messagesEndRef} />
                        )}
                        <Message
                            key={"nr_answer" + index}
                            message={discussion.answer}
                        />
                    </>
                );
            })}
            {currentQuestion && isLoadingResponse && (
                <Message
                    key={"currentQuestion"}
                    message={currentQuestion}
                    isQuestion={true}
                />
            )}
            {isLoadingResponse && <TypingIndicator />}
        </Flex>
    );
};

export default MessagesContainer;
